import React from "react";
import styles from "./EventDetailsHero.module.css";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";

interface EventDetailsHeroProps {
  data: any;
}

const EventDetailsHero: React.FC<EventDetailsHeroProps> = ({ data }) => {
  const { title } = data;

  return (
    <div className={`${styles.heroContainer}`}>
      <div className="container">
        <Breadcrumbs classValue="boxStyle" />
        <h1 className={styles.title}>{title}</h1>
      </div>
    </div>
  );
};

export default EventDetailsHero;
